import { createContext, useContext } from 'react';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { appInsights } from './applicationInsights';

export const AppInsightsContext = createContext<ApplicationInsights>(appInsights);

export const useAppInsights = (): ApplicationInsights => useContext(AppInsightsContext);
